import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import { getSubscriptionTitle } from '../../helpers';

import * as S from '../styled';

import { IBillingPeriod } from '../../types';

const BillingPeriod = ({ period }: IBillingPeriod) => {
    const { t } = useTranslation();

    const label = getSubscriptionTitle(period, false);

    return (
        <S.SubscriptionCardRow>
            <Text>{t('subscription.text.billingPeriod')}</Text>
            <Text>
                <Trans
                    i18nKey="basic.periods"
                    values={{
                        count: label?.count,
                        context: label?.context,
                    }}
                />
            </Text>
        </S.SubscriptionCardRow>
    );
};

export default BillingPeriod;
